import React, { useState, useEffect } from "react";

export default function DateRangeFilter({ onDateChange }) {
  const [range, setRange] = useState("");
  const [customRange, setCustomRange] = useState({ start: "", end: "" });

  // Update parent whenever range or custom range changes
  useEffect(() => {
    let start = ''
    let end = ""
    const today = new Date();
    if (range === "today") {
      start = today.toISOString().split("T")[0];
      end = today.toISOString().split("T")[0];
    } else if (range === "yesterday") {
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      start = yesterday.toISOString().split("T")[0];
      end = yesterday.toISOString().split("T")[0];
    }
    else if (range === "last7") {
      const last7 = new Date(today);
      last7.setDate(today.getDate() - 6);
      start = last7.toISOString().split("T")[0];
      end = today.toISOString().split("T")[0];
    } else if (range === "month") {
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      start = firstDay.toISOString().split("T")[0];
      end = today.toISOString().split("T")[0];
    } else if (range === "custom") {
      start = customRange.start || "";
      end = customRange.end || "";
    }

    onDateChange({ start, end });
  }, [range, customRange, onDateChange]);

  const handleCustomChange = (type, value) => {
    setCustomRange((prev) => ({ ...prev, [type]: value }));
  };

  return (
    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
      <select
        value={range}
        onChange={(e) => setRange(e.target.value)}
        style={{
          padding: "6px",
          borderRadius: "4px",
          border: "1px solid #ccc",
          cursor: "pointer",
        }}
      >
        <option value="">Date Filter</option>
        <option value="today">Today</option>
        <option value="yesterday">Yesterday</option>
        <option value="last7">Last 7 Days</option>
        <option value="month">This Month</option>
        <option value="custom">Custom</option>
      </select>

      {range === "custom" && (
        <>
          <input
            type="date"
            value={customRange.start}
            onChange={(e) => handleCustomChange("start", e.target.value)}
            style={{ padding: "6px", borderRadius: "4px", border: "1px solid #ccc" }}
          />
          <span>to</span>
          <input
            type="date"
            value={customRange.end}
            onChange={(e) => handleCustomChange("end", e.target.value)}
            style={{ padding: "6px", borderRadius: "4px", border: "1px solid #ccc" }}
          />
        </>
      )}
    </div>
  );
}
